import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { getAutoDeleteTime, getToasts } from 'store/features/toasts/selectors';
import { removeToast } from 'store/features/toasts/actions';
import { AppDispatch, RootState } from 'store/types';

import Toasts from './Toasts';

const mapStateToProps = (state: RootState) => ({
  list: getToasts(state),
  autoDeleteTime: getAutoDeleteTime(state),
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  actions: bindActionCreators({ removeToast }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Toasts);
